import type { SiteQuizCopy } from '@/utils/rateQuiz/siteQuizzes';

/** The UK quiz in the bidmio.com hub, quiz tabs and header menu. */
export const EN_RIGHTS_SITE_QUIZ: SiteQuizCopy = {
  title: 'Your duties and rights as a tradesperson (UK)',
  description:
    'Seven quick questions, then only what applies to you: deadlines for tax, CIS, employees and customer contracts, and what the law gives you. Every point links to its source.',
  short: 'Duties and rights',
  menuLabel: 'What are your duties and rights as a UK tradesperson?',
};
